export const VIDEO_STATUS = {
  'processing': {
    isError: false,
    description: 'Processing'
  },
  'error': {
    isError: true,
    description: 'Processing failed'
  },
  'captions-pending': {
    isError: false,
    description: 'Queued for enhancement'
  },
  'captioning': {
    isError: false,
    description: 'Captions processing'
  },
  'captioning-failed': {
    isError: true,
    description: 'Unable to generate captions'
  },
};
